import { formatTermDate } from "@/lib/term-state";
import type { ListBox } from "@/components/ui/box.schema";
import { STRUCTURE_OBJECT } from "./structure-visits";
import type { StructureKind, StructureRow } from "./use-structure-models";

/** Scanning stays compact; editing opens the same exact record from any origin. */
export function structureRegister(kind: StructureKind, list: ListBox<StructureRow[], StructureRow>): ListBox<StructureRow[], StructureRow> {
  const columns = kind === "semester" ? [{ id: "dates", label: "Dates" }, { id: "due", label: "Grades due" }, { id: "sections", label: "Sections" }]
    : kind === "program" ? [{ id: "code", label: "Code" }, { id: "parent", label: "Department" }, { id: "sections", label: "Sections" }]
    : kind === "department" ? [{ id: "programs", label: "Programs" }, { id: "sections", label: "Sections" }]
    : [{ id: "parent", label: "Program" }, { id: "year", label: "Entry year" }, { id: "learners", label: "Learners" }];
  return { ...list, figureLayout: "inline", detail: () => "",
    table: { title: "Record", columns },
    row: {
      key: list.row.key, title: list.row.title,
      facts: list.row.facts, state: list.row.state,
      act: row => ({ does: "visit", verb: "Open record", visit: `${STRUCTURE_OBJECT[kind]}:${row.id}` }),
      cells: row => columns.map(column => ({ id: column.id, read:
        column.id === "dates" && "start_date" in row ? `${row.start_date ? formatTermDate(row.start_date) : "Not set"} - ${row.end_date ? formatTermDate(row.end_date) : "Not set"}`
          : column.id === "due" && "grades_due_date" in row ? row.grades_due_date ? formatTermDate(row.grades_due_date) : "Not set"
          : column.id === "code" && "code" in row ? row.code ?? "Not set"
          : column.id === "parent" && "department_name" in row ? row.department_name ?? "Unassigned"
          : column.id === "parent" && "program_name" in row ? row.program_name ?? "Unassigned"
          : column.id === "programs" && "program_count" in row ? String(row.program_count)
          : column.id === "year" && "entry_year" in row ? String(row.entry_year)
          : column.id === "learners" && "student_count" in row ? String(row.student_count)
          : column.id === "sections" && Number.isInteger(row.section_count) ? String(row.section_count) : "Unread" })),
    },
  };
}
